<template>
  <div class="wlx-tea-basic-info-main">
    <el-form ref="form" :model="form" label-width="100px" class="tea-info-form">
      <el-form-item label="姓名：">
        <el-input v-model="form.Name"></el-input>
      </el-form-item>
      <el-form-item label="头像：">
        <imageUpload :url="urlAliyunOSS" :files.sync="form.CoverUrl" format="image"></imageUpload>
      </el-form-item>
      <el-form-item label="性别：">
        <el-radio-group v-model="form.Gender">
          <el-radio label="0">男</el-radio>
          <el-radio label="1">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="所在学校:">
          <el-select v-model="form.SchoolId" clearable placeholder="请选择">
            <el-option
              v-for="item in schoolList"
              :key="item.Id"
              :label="item.SchoolName"
              :value="item.Id">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="工号：">
        <el-input v-model="form.Number"></el-input>
      </el-form-item>
      <el-form-item label="身份证号：">
        <el-input v-model="form.IDNumber"></el-input>
      </el-form-item>
      <el-form-item label="手机号：">
        <el-input disabled v-model="form.Mobile"></el-input>
      </el-form-item>
      <el-form-item label="简介：">
        <el-input type="textarea" :rows="4" v-model="form.Desc"></el-input>
      </el-form-item>
    </el-form>

    <el-button type="primary" @click="updateBasicInfo">保 存</el-button>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      form: {
        UserId: "",
        Name: "",
        CoverUrl: "",
        Gender: "",
        IDNumber: "",
        Number:"",
        Mobile: "",
        Desc: "",
        SchoolId: ""
      },
      urlAliyunOSS: "/api/design/osssign/getsign",
      schoolList:[],
    };
  },
  components: {
    imageUpload
  },
  created() {
    this.getBasicInfo();
    this.getSchoolList();
  },
  methods: {
    getSchoolList() {
      let self = this;
      this.$http.get("/api/XOrg/StudentManager/getSchoolList").then(function(res) {
        if (res.code == 1) {
          self.schoolList = res.schoolList;
        }
      });
    },
    getBasicInfo() {
      let self = this;
      this.$http.get("/api/XOrg/teaBasicInfo/getBasicInfo").then(function(res) {
        if (res.code == 1) {
          self.form.UserId = res.userInfo.id;
          self.form.Name = res.userInfo.name;
          self.form.CoverUrl = res.userInfo.cover;
          self.form.Gender = res.userInfo.gender;
          self.form.IDNumber = res.userInfo.iDNumber;
          self.form.SchoolId = res.userInfo.schoolId;
          self.form.Number = res.userInfo.number;
          self.form.Mobile = res.userInfo.mobile;
          self.form.Desc = res.userInfo.description;
        }
      });
    },
    testid(card) {
      var str, result = 0;
        card = card.toUpperCase();
        if (card.length === 18) {
            var map1 = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
                map2 = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

            str = new String(card);
            for (var i = 0, len = str.length; i < (len - 1); i++) {
                result += str[i] * map1[i];
            }
            if (map2[(result % 11)] != str[len - 1]) {
                return "请填写正确的身份证号码！"
            }else{
                return "1"
            }
        }else{
          return "请填写正确的身份证号码！";
        }
    },
    updateBasicInfo() {
      let self = this;
      var code= self.testid(this.form.IDNumber);
      if(code!=1){
        this.$message({
          showClose: true,
          message: code,
          type: 'warning'
        });
        return false;
      }
      this.$http
        .post("/api/XOrg/teaBasicInfo/updateBasicInfo", {
          userId: this.form.UserId,
          name: this.form.Name,
          coverUrl: this.form.CoverUrl,
          gender: this.form.Gender,
          iDNumber: this.form.IDNumber,
          schoolId: this.form.SchoolId,
          number: this.form.Number,
          mobile: this.form.Mobile,
          desc: this.form.Desc
        })
        .then(function(res) {
          if (res.code == 1) {
            self.$message.success(res.msg);
            self.getBasicInfo();
          }else{
            self.$message.warning(res.msg);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.wlx-tea-basic-info-main{
  .tea-info-form{
    width: 50%;
  }
}
</style>
